import React, { FC } from 'react';
import { IconButton, Stack, Tooltip } from '@mui/material';
import { AddTask, FileUploadOutlined, Remove } from '@mui/icons-material';
import { useAppTFunction } from '@retail/app/i18n';

interface Props {
  isNonStockSupplier: boolean;
  onUpdateNonStockSupplier?: () => void;
  onUploadAgreementsClick?: () => void;
}

export const SuppliersTableActions: FC<Props> = ({
  isNonStockSupplier,
  onUpdateNonStockSupplier,
  onUploadAgreementsClick,
}) => {
  const t = useAppTFunction();

  return (
    <Stack direction="row" spacing={0.5}>
      {onUpdateNonStockSupplier && (
        <Tooltip
          title={
            isNonStockSupplier
              ? t('suppliers.nonStockItemSupplier.remove')
              : t('suppliers.nonStockItemSupplier.add')
          }
        >
          <IconButton onClick={onUpdateNonStockSupplier}>
            {isNonStockSupplier ? <Remove fontSize="small" /> : <AddTask fontSize="small" />}
          </IconButton>
        </Tooltip>
      )}
      {onUploadAgreementsClick && (
        <Tooltip title={t('purchaseAgreements.agreement.prices.upload.title')}>
          <IconButton onClick={onUploadAgreementsClick}>
            <FileUploadOutlined />
          </IconButton>
        </Tooltip>
      )}
    </Stack>
  );
};
